import { createContext, useContext, useSyncExternalStore } from 'react';
import type { PanelState, PanelStore } from './store.js';

export const StoreContext = createContext<PanelStore | null>(null);

export function useStore(): PanelStore {
  const store = useContext(StoreContext);
  if (!store) throw new Error('PanelStore is missing; wrap the tree in <StoreContext.Provider>');
  return store;
}

/** The whole panel state; components re-render when any part changes. */
export function usePanel(): PanelState {
  const store = useStore();
  return useSyncExternalStore(store.subscribe, store.getState, store.getState);
}
